<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Cihaz İsmi</label>
            <input class="form-control" placeholder="Cihaz İsmi" v-model="value.Alias"/>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    }
}
</script>